/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Header_Startfree1Inputs */

const zh_landing_header_startfree1 = /** @type {(inputs: Landing_Header_Startfree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const en_landing_header_startfree1 = /** @type {(inputs: Landing_Header_Startfree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start for free`)
};

const es_landing_header_startfree1 = /** @type {(inputs: Landing_Header_Startfree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis`)
};

/**
* | output |
* | --- |
* | "Start for free" |
*
* @param {Landing_Header_Startfree1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_header_startfree1 = /** @type {((inputs?: Landing_Header_Startfree1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Header_Startfree1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_header_startfree1(inputs)
	if (locale === "en") return en_landing_header_startfree1(inputs)
	return es_landing_header_startfree1(inputs)
});
export { landing_header_startfree1 as "landing_header_startFree" }